import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=aa570f6a&scoped=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"
import style0 from "./layout.vue?vue&type=style&index=0&id=aa570f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa570f6a",
  null
  
)

export default component.exports